<h1>Quotes</h1>

<div class="container my-4">
    @if (quotes) {
    <div class="d-flex justify-content-end mb-3">
        <a class="col-4 col-md-3 col-lg-2 btn btn-primary" [routerLink]="['/', 'quote-create-quick']">New Quote</a>
    </div>

    <input class="mb-3 form-control" type="text" placeholder="Search Quotes" [(ngModel)]="searchText" />

    @for (quote of getFilteredQuotes(); track quote.id) {
    <div class="card mb-3 shadow-sm">
        <div class="card-body">
            <!-- Top: Quote # and Status -->
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-start mb-3">
                <a [routerLink]="['/', 'quote-view', quote.id]" class="text-decoration-none">
                    <h5 class="card-title mb-1">Quote #{{ quote.number }}</h5>
                </a>
                <span class="badge bg-primary text-capitalize mt-2 mt-md-0">{{ quote.status }}</span>
            </div>

            <!-- Info Row 1: Customer + Sales Rep -->
            <div class="row gx-3 gy-2">
                <div *ngIf="quote.customerName" class="col-12 col-md-6">
                    <div class="fw-bold d-md-inline-block d-block">Customer</div>
                    <span class="ms-md-2">{{ quote.customerName }}</span>
                </div>

                <div *ngIf="quote.salesRepName" class="col-12 col-md-6">
                    <div class="fw-bold d-md-inline-block d-block">Sales Rep</div>
                    <span class="ms-md-2">{{ quote.salesRepName }}</span>
                </div>
            </div>

            <!-- Info Row 2: Date (always full width) -->
            <div *ngIf="quote.date" class="row gx-3 gy-2 mt-2">
                <div class="col-12">
                    <div class="fw-bold d-md-inline-block d-block">Date</div>
                    <span class="ms-md-2">{{ quote.date | utcToLocal }}</span>
                </div>
            </div>
        </div>
    </div>

    }
    } @else {
    <app-loading></app-loading>
    }
</div>